/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CheckoutIntent = zod.enum(['payment_method_setup', 'payment_method_update']);

export type CheckoutIntent = zod.input<typeof CheckoutIntent>;
export type CheckoutIntentOutput = zod.output<typeof CheckoutIntent>;
